<template>
    <div class="l-app-main-section">
        <div class="ui padded relaxed equal width grid">
            <div class="middle aligned row">
                <div class="column">
                    <h3>All Users</h3>
                    <small>{{totalUser}} users</small>
                </div>
                <div class="right aligned column">
                    <button class="ui bg-primary button" @click="addUser">Add User</button>
                </div>
            </div>
            <div class="computer only tablet only row">
                <div class="column">
                    <table class="ui celled styled unstackable table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Contact Details</th>
                                <th class="six wide">Last Login Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tr v-for="(transc, index) in userLists" :key="index">
                            <td class="collapsing center aligned">{{index + 1}}</td>
                            <td>
                                <h4>{{transc.full_names}}</h4>
                            </td>
                            <td>
                                <div>{{transc.msisdn}}</div>
                                <small>{{transc.email_address}}</small>
                            </td>
                            <td>{{transc.last_successful_date | formatDate}}</td>
                            <td class="right aligned collapsing">
                                <button class="ui tiny button" @click="permissionChange(transc.msisdn, transc.permission_acl, transc.user_mapId)">Manage Permission</button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="mobile only row bg-white border-top border-bottom border-light">
                <div class="column">
                    <table class="ui very basic unstackable table">
                        <tbody>
                        <tr v-for="(transc, index) in userLists" :key="index">
                            <td>
                                <div class="border-right border-light padding-right-xs">
                                    <h4>{{transc.full_names}}</h4>
                                    <small class="text-grey"><span class="padding-right-md">{{transc.msisdn}}</span> <span class="padding-right-sm">{{transc.email_address}}</span></small>
                                </div>
                            </td>
                            <td class="right aligned">
                                <button class="ui tiny button" @click="permissionChange(transc.msisdn, transc.permission_acl, transc.user_mapId)">Manage</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <UserAdd />
        <ClientPermission />
        <shareCredits />
    </div>
</template>

<script>
    import loader from "@/components/loader";
    import store from "@/store";
    import bulkstore from "@/bulk/bulksms-state";
    import alertify from "alertifyjs";
    import UserAdd from "@/modals/user-add";
    import ClientPermission from "@/modals/client-permission";
    import shareCredits from "@/modals/share-credits";
    import moment from "moment";
    export default {
        data() {
            return {
                userLists: [],
                limit: 10,
                offset: 0,
                loading: true,
                totalUser:0
            }
        },
        components: {
            UserAdd,
            loader,
            ClientPermission,
            shareCredits
        },
        mounted() {
            let vm = this;
            $(".ui.dropdown").dropdown();
            vm.fetchUsers();
        },
        methods: {
            addUser() {
                $(".ui.modal#modal-user-add").modal({
                    centered: false
                }).modal('show');
            },
            share(username,user_mapId) {
                store.commit("setClientUsername",username);
                store.commit("setClientUser_mapId",user_mapId);
                $(".ui.modal#modal-share-credits").modal({
                    centered: false
                }).modal('show');
            },
            permissionChange(username,permissionDT,user_mapId) {
                //console.log("usermame "+permissionDT);
                store.commit("setClientUsername",username);
                store.commit("setPermission",permissionDT);
                store.commit("setClientUser_mapId",user_mapId);
                $(".ui.modal#modal-client-permission").modal({
                    centered: false
                }).modal('show');
            },
            fetchUsers() {
                let vm = this;
                $.post({
                    url: store.state.rootURLBulkAPI + 'v2/users/view',
                    type: "POST",
                    data: JSON.stringify({
                        apiKey: vm.$cookies.get("key"),
                        user_name: "",
                        start: "",
                        end: "",
                        offset: ",",
                        limit: vm.limit,
                        sort: "",
                        export: ""
                    }),
                    success: function(response, status, jQxhr) {
                        vm.loading = false;
                        vm.userLists = response.data.data;
                        setTimeout(function(){
                            $(".ui.dropdown").dropdown();
                        }, 500)
                        vm.totalUser = response.data.record_count;
                        //console.log(JSON.stringify(vm.userLists));
                    },
                    error: function(jQxhr, status, error) {
                        vm.loading = false;
                        //console.log(" status" + status + " data " + JSON.stringify(jQxhr.responseJSON.statusDescription));
                    }
                });
            },
        },
        filters: {
            formatDate: function(value) {
                if (!value) return ''
                return moment(value).fromNow()
            },
        }
    }
</script>